export default __webpack_public_path__ + "static/media/newsletter2.5788f2a5.jpeg";